export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const SET_OWNER_ID = 'SET_OWNER_ID';
export const SET_IS_FOLLOWING_INKIND = 'SET_IS_FOLLOWING_INKIND';
export const SET_INKIND_TITLE = 'SET_INKIND_TITLE';
export const SET_INKIND_ID = 'SET_INKIND_ID';
export const SET_INKIND_ROUTE_ID = 'SET_INKIND_ROUTE_ID';
export const SET_INKIND_PAGE_THUMBNAIL_SMALL = 'SET_INKIND_PAGE_THUMBNAIL_SMALL';
export const SET_TIMEZONE = 'SET_TIMEZONE';
export const SET_CALENDAR_TIMEZONE = 'SET_CALENDAR_TIMEZONE';
export const SET_CALENDAR_TIMEZONE_DISPLAY = 'SET_CALENDAR_TIMEZONE_DISPLAY';
export const SET_RECIPIENT_CONTACT_INFORMATION = 'SET_RECIPIENT_CONTACT_INFORMATION';
export const SET_USER_NAME = 'SET_USER_NAME';

export function login(userId) {
  return { type: LOGIN, userId };
}

export function logout() {
  return { type: LOGOUT };
}

export function setOwnerId(id) {
  return { type: SET_OWNER_ID, id };
}

export function setUserName(userFirstName, userLastName) {
  return { type: SET_USER_NAME, userFirstName, userLastName };
}

export function setIsFollowingInkind(isFollowingInkind) {
  return { type: SET_IS_FOLLOWING_INKIND, isFollowingInkind };
}

export function setInkindPageThumbnailSmall(inkindPageThumbnailSmall) {
  return { type: SET_INKIND_PAGE_THUMBNAIL_SMALL, inkindPageThumbnailSmall };
}

export function setInkindTitle(inkindTitle) {
  return { type: SET_INKIND_TITLE, inkindTitle };
}

export function setInkindId(id) {
  return { type: SET_INKIND_ID, id };
}

export function setInkindRouteId(routeId) {
  return { type: SET_INKIND_ROUTE_ID, routeId };
}

export function setTimezone(timezone) {
  return { type: SET_TIMEZONE, timezone };
}

export function setCalendarTimezone(calendarTimezone) {
  return { type: SET_CALENDAR_TIMEZONE, calendarTimezone };
}

export function setCalendarTimezoneDisplay(display) {
  return { type: SET_CALENDAR_TIMEZONE_DISPLAY, display };
}

export function setRecipientContactInformation(recipientContactInformation) {
  return { type: SET_RECIPIENT_CONTACT_INFORMATION, recipientContactInformation };
}
